import React from "react";
import { Outlet } from "react-router-dom";
import Tabs from "../../../components/common/Tabs"


  const tabs = [
    {
      link: "/accounting/bank_transfers_incomplete/incomplete",
      title: "Incomplete Transfers",
    },
    {
      link: "/accounting/bank_transfers_incomplete/completed",
      title: "Completed Transfers",
    },
  ];

function BankTransfers() {
  return (
    <>
     <Tabs tabs={tabs}/>
     <Outlet />
    </>
  );
}

export default BankTransfers;